import React, { useMemo, useRef } from "react";
import { useSelector } from "react-redux";
import { Title, Carousel, Tab, useTheme } from "@bookingcom/bui-react";
import { t } from "@bookingcom/lingojs-core";
import { useI18n } from "@bookingcom/lingojs-react";
import FlightsNearbyItem from "./PopularFlightsItem.js";
import Container from "../Container/index.js";
import Frame from "../Frame/index.js";
import styles from "./PopularFlights.module.css";
import { useTrackLandingPageViewport } from "../../../hooks/c360/useLandingPageEvents.js";
import { getPopularFlights } from "../../../store/popularFlights/selectors.js";
const [DOMESTIC, INTERNATIONAL] = ["DOMESTIC", "INTERNATIONAL"];
const Wrapper = ({ isMobile, children }) => {
    const theme = useTheme();
    return isMobile ? (React.createElement(Frame, { grow: 1, p: 4, attributes: { style: { width: "100%" } } }, children)) : (React.createElement(Container, { style: { margin: `${theme.units.spacing_8x} auto`, alignItems: "start" } }, children));
};
const PopularFlights = ({ isMobile }) => {
    const i18n = useI18n();
    const popularFlights = useSelector(getPopularFlights);
    const scrollRef = useRef(null);
    const domesticPopularFlights = useMemo(() => {
        return popularFlights?.filter((flight) => flight.isDomestic) || [];
    }, [popularFlights]);
    const internationalPopularFlights = useMemo(() => {
        return popularFlights?.filter((flight) => !flight.isDomestic) || [];
    }, [popularFlights]);
    useTrackLandingPageViewport(scrollRef, "popular_flights");
    const triggerList = [
        {
            text: i18n.trans(t("seo_flights_new_index_lp_cheap_flights_international_toggle")),
            id: INTERNATIONAL
        },
        {
            text: i18n.trans(t("seo_flights_new_index_lp_cheap_flights_domestic_toggle")),
            id: DOMESTIC
        }
    ];
    const panelList = [
        {
            id: DOMESTIC,
            children: (React.createElement(Carousel, { attributes: { id: `home_carouse_${DOMESTIC}` }, className: styles.carousel, size: isMobile ? "large" : "medium", nextButtonAriaLabel: i18n.trans(t("a11y_flights_route_carousel_next_button_aria_label")), previousButtonAriaLabel: i18n.trans(t("a11y_flights_route_carousel_previous_button_aria_label")) }, domesticPopularFlights.map((flight, index) => (React.createElement(FlightsNearbyItem, { key: `dom-${index}`, flight: flight, index: index, isMobile: isMobile, component: "popular_flights_domestic" })))))
        },
        {
            id: INTERNATIONAL,
            children: (React.createElement(Carousel, { attributes: { id: `home_carouse_${INTERNATIONAL}` }, className: styles.carousel, size: isMobile ? "large" : "medium", nextButtonAriaLabel: i18n.trans(t("a11y_flights_route_carousel_next_button_aria_label")), previousButtonAriaLabel: i18n.trans(t("a11y_flights_route_carousel_previous_button_aria_label")) }, internationalPopularFlights.map((flight, index) => (React.createElement(FlightsNearbyItem, { key: `int-${index}`, flight: flight, index: index, isMobile: isMobile, component: "popular_flights_international" })))))
        }
    ];
    const renderTabbedCarousels = () => {
        return (React.createElement(Tab, { className: styles.tabs, defaultActiveTabId: triggerList[0].id },
            React.createElement(Tab.TriggerList, null, triggerList.map((trigger) => (React.createElement(Tab.Trigger, { key: trigger.id, linkAttributes: { "aria-label": trigger.text }, ...trigger })))),
            React.createElement("div", { ref: scrollRef }, panelList.map((panel) => (React.createElement(Tab.Panel, { key: panel.id, id: panel.id, attributes: { "aria-label": triggerList.find((trigger) => trigger.id === panel.id)?.text } },
                React.createElement("div", { className: styles.tabPanelContent }, panel.children)))))));
    };
    const renderSingleCarousel = (flights) => {
        return (React.createElement(Carousel, { className: styles.carousel, size: isMobile ? "large" : "medium", nextButtonAriaLabel: i18n.trans(t("a11y_flights_route_carousel_next_button_aria_label")), previousButtonAriaLabel: i18n.trans(t("a11y_flights_route_carousel_previous_button_aria_label")) }, flights.map((flight, index) => (React.createElement(FlightsNearbyItem, { key: `che-${index}`, flight: flight, index: index, isMobile: isMobile, component: "popular_flights_nearby" })))));
    };
    return popularFlights && popularFlights.length > 0 ? (React.createElement(Wrapper, { isMobile: isMobile },
        React.createElement(Title, { className: domesticPopularFlights.length > 0 && internationalPopularFlights.length > 0
                ? styles.tabbedCarouselTitle
                : styles.singleCarouselTitle, title: i18n.trans(t("seo_flights_new_index_lp_popular_flights_header")), subtitle: i18n.trans(t("seo_flights_new_index_lp_cheap_flights_subheader")), variant: "headline_2", titleTagName: "h2" }),
        React.createElement("div", null, domesticPopularFlights.length > 0 && internationalPopularFlights.length > 0
            ? renderTabbedCarousels()
            : renderSingleCarousel(popularFlights)))) : null;
};
export default PopularFlights;
